var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2251",
    "data-name": "Group 2251",
    transform: "translate(-30 -424)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_79",
    "data-name": "Ellipse 79",
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    transform: "translate(30 424)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2239",
    "data-name": "Group 2239",
    transform: "translate(768.278 -1495.756)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3558",
    "data-name": "Path 3558",
    d: "M-727,1940.244l-4.561-1.129a.946.946,0,0,1-.719-.918v-9.215a.946.946,0,0,1,1.174-.919l4.561,1.129a.946.946,0,0,1,.719.919v9.214A.946.946,0,0,1-727,1940.244Z",
    transform: "translate(0 -0.847)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3559",
    "data-name": "Path 3559",
    d: "M-732.278,1936.866v-8.994a.946.946,0,0,1,.946-.946h7.57a.946.946,0,0,1,.946.946v3.461",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3560",
    "data-name": "Path 3560",
    d: "M-701.739,1957.131v3.031a.946.946,0,0,1-.946.946h-2.04",
    transform: "translate(-21.035 -23.059)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_84",
    "data-name": "Line 84",
    x2: 5.495,
    transform: "translate(-724.289 1932.731)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3561",
    "data-name": "Path 3561",
    d: "M-685.279,1946.276l2.366-2.366-2.294-2.294",
    transform: "translate(-35.881 -11.214)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.aa630c30ae8e118f2e897ff8ad6a4dcb.svg";
export { ForwardRef as ReactComponent };